module.exports = __webpack_public_path__ + "static/media/footer-recherche.d7b95e6f.png";